import React, { useState } from 'react';
import { Input, Button, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const CepInput = ({ value, onChange, onAddressChange, size = 'default', placeholder = 'Digite o CEP' }) => {
  const [loading, setLoading] = useState(false);

  const formatCep = (cep) => {
    const numbers = cep.replace(/\D/g, '');
    return numbers.replace(/(\d{5})(\d{3})/, '$1-$2');
  };

  const searchCep = async (cep) => {
    const cleanCep = cep.replace(/\D/g, '');
    
    if (cleanCep.length !== 8) {
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);
      const data = await response.json();

      if (data.erro) {
        message.error('CEP não encontrado');
        return;
      }

      // Buscar coordenadas usando Nominatim
      const address = `${data.logradouro}, ${data.bairro}, ${data.localidade}, ${data.uf}, Brasil`;
      let coordinates = { latitude: null, longitude: null };
      
      try {
        const geoResponse = await fetch(
          `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}&limit=1`
        );
        const geoData = await geoResponse.json();

        if (geoData.length > 0) {
          coordinates = {
            latitude: parseFloat(geoData[0].lat),
            longitude: parseFloat(geoData[0].lon)
          };
          console.log('Coordenadas específicas encontradas:', coordinates);
        } else {
          // Se não encontrou coordenadas específicas, buscar da cidade
          console.log('Buscando coordenadas da cidade:', data.localidade);
          const cityResponse = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(data.localidade + ', ' + data.uf + ', Brasil')}&limit=1`,
            {
              headers: {
                'User-Agent': 'Futezap-Admin/1.0'
              }
            }
          );
          const cityData = await cityResponse.json();
          
          if (cityData.length > 0) {
            coordinates = {
              latitude: parseFloat(cityData[0].lat),
              longitude: parseFloat(cityData[0].lon)
            };
            console.log('Coordenadas da cidade encontradas:', coordinates);
          } else {
            console.warn('Nenhuma coordenada encontrada para cidade:', data.localidade);
          }
        }
      } catch (geoError) {
        console.error('Erro ao buscar coordenadas:', geoError);
      }

      const addressData = {
        address: `${data.logradouro}, ${data.bairro}`,
        city: data.localidade,
        state: data.uf,
        neighborhood: data.bairro,
        ...coordinates
      };

      if (onAddressChange) {
        onAddressChange(addressData);
      }

      message.success('Endereço encontrado!');
    } catch (error) {
      console.error('Erro ao buscar CEP:', error);
      message.error('Erro ao buscar CEP');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const formatted = formatCep(e.target.value);
    if (onChange) {
      onChange(formatted);
    }
  };

  const handleBlur = (e) => {
    const cep = e.target.value.replace(/\D/g, '');
    if (cep.length === 8) {
      searchCep(cep);
    }
  };

  const handleSearch = () => {
    const cep = (value || '').replace(/\D/g, '');
    if (cep.length === 8) {
      searchCep(cep);
    } else {
      message.warning('Digite um CEP válido com 8 dígitos');
    }
  };

  return (
    <Input.Group compact>
      <Input
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        maxLength={9}
        size={size}
        style={{ width: 'calc(100% - 40px)' }}
      />
      <Button 
        icon={<SearchOutlined />}
        onClick={handleSearch}
        loading={loading}
        size={size}
        type="primary"
        style={{ width: '40px' }}
      />
    </Input.Group>
  );
};

export default CepInput;